<template>
      <button type="button" style="display: none;" data-bs-toggle="modal" data-bs-target="#cardModal" id="cardModalBTN"></button>
<div class="modal fade" id="cardModal" tabindex="-1" role="dialog">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-body">
                <div style="display:flex;justify-content:space-between">
                    <h3 class="agileinfo_sign text-center" >
                      <i class="fa fa-barcode"></i>
                      فاکتور {{card.modeFa}}
                    </h3>
                    <button type="button" class="btn-close" data-bs-dismiss="modal"  id="cashModalCloseBTN"></button>
                </div>
                <div class="w-100 p-3 rounded mt-3" style="background-color:#e5e5e5">
                      <div style="display:flex;justify-content:space-between">
                          <p>شماره تلفن:</p><span>{{card.mobile}}</span>
                      </div>
                      <div style="display:flex;justify-content:space-between">
                          <p>قیمت واحد:</p><span>{{numberFormat(card.amount)}} تومان</span>
                      </div>
                      <div style="display:flex;justify-content:space-between">
                          <p class="mb-0">اپراتور</p><span>{{card.operatorFa}}</span>
                      </div>
                      <div>
                        <p style="margin-top: 17px; text-align: center; " v-if="card.mode =='internet'">تمامی بسته ها با احتساب مالیات بر ارزش افزوده محاسبه گردیده است</p>
                    </div>
                  </div>
                  <div class="w-100 p-3 rounded mt-3" style="background-color:#e5e5e5">
                      <div style="display:flex;justify-content:space-between">
                          <p class="mb-0">مبلغ قابل پرداخت:</p><span class="text-success">{{numberFormat(card.amount)}} تومان</span>
                      </div>
                  </div>
                  <div style="display:flex;justify-content:space-between" class="mt-3">
                      <button class="btn btn-success w-70" v-if="payLoading">
                        <div class="spinner-border text-light" role="status" style="vertical-align: middle;margin-left: 10px;width: 20px;height: 20px;">
                          <span class="visually-hidden">Loading...</span>
                        </div>
                          لطفا شکیبا باشید
                      </button>
                      <button class="btn btn-success w-70" @click="goPay" v-else >تایید و پرداخت</button>
                      <button class="btn w-25" style="background-color:#e5e5e5" data-bs-dismiss="modal" >انصراف</button>
                  </div>
            </div>
        </div>
    </div>
</div>
</template>
  
<script setup>
import axios from 'axios';
import { ref, onMounted} from 'vue'
import { alertBox } from '@/composables/silverBox' 
import { convertToEnglish, numberFormat } from '@/composables/digits' 
import { useAuth } from '@/store/auth'
import { useCard } from '@/store/card'
let auth = useAuth()
let card = useCard()
let payLoading = ref(false)
function goPay(){
    payLoading.value = true
    if(card.mode == 'charge'){
      const formData = new FormData()
      formData.append('token', auth.token)
      formData.append('mobile', convertToEnglish(card.mobile))
      formData.append('operator', card.operator)
      formData.append('amount', convertToEnglish(card.amount))
      formData.append('charge_type', card.type)
      formData.append('mnp', card.mnp)
      axios.post('https://radap.ir/Backend/api/section/card/charge.php', formData)
      .then(res=>{
        payLoading.value = false
        if(res.data.code == 1 ){
          alertBox('لحظاتی بعد به صفحه پرداخت منتقل می شوید','success')
          window.location.href =  res.data.url;
        }else{
          payLoading.value = false
          alertBox(res.data.msg)
        }
      })
    }else{
      const formData = new FormData()
      formData.append('token', auth.token)
      formData.append('mobile', convertToEnglish(card.mobile))
      formData.append('operator', card.operator)
      formData.append('charge_type', card.type)
      formData.append('mnp', card.mnp)
      formData.append('product_id', card.packageId)
      formData.append('priod', card.priod)
      formData.append('amount', convertToEnglish(card.amount))
      formData.append('pack_name', card.packageName)
      axios.post('https://radap.ir/Backend/api/section/card/internet.php', formData)
      .then(res=>{
        payLoading.value = false
        if(res.data.code == 1){
          alertBox('لحظاتی بعد به صفحه پرداخت منتقل می شوید','success')
          window.location.href = res.data.url;
        }else{
          alertBox(res.data.msg)
        }
      })
    }
}
</script>
  
<style scoped>
  h3{
    font-size: 15px !important;
    font-weight: 700;
    letter-spacing: 0 !important;
  }
  p{
    letter-spacing: 0 !important;
  }
  .w-40{
    width: 40%;
  }
  .w-70{
    width: 70%;
  }
</style>